import { iUser } from '@/entities/user/user.types';
import serviceProvider from '@/services/service-provider';
import { ObjectLike } from '@/types/objectlike.types';

export default function useReviewActionsFunctions(
  $store: any,
  reviewActionsVariables: ObjectLike,
  likeReviewVariables: ObjectLike,
) {
  async function like() {
    const storeUser: iUser = $store.getters['user/user'];
    const { reviewInstance } = reviewActionsVariables;
    const { likeClicked } = likeReviewVariables;

    likeClicked.value = true;
    const newReview = await serviceProvider.review.like(reviewInstance.value, storeUser.id);
    reviewInstance.value = newReview;
    likeClicked.value = false;
  }

  async function unlike() {
    const storeUser: iUser = $store.getters['user/user'];
    const { reviewInstance } = reviewActionsVariables;
    const { likeClicked } = likeReviewVariables;

    likeClicked.value = true;
    const newReview = await serviceProvider.review.unlike(reviewInstance.value, storeUser.id);
    reviewInstance.value = newReview;
    likeClicked.value = false;
  }

  async function onLikeClicked() {
    const { hasLike } = likeReviewVariables;

    if (hasLike.value) {
      return unlike();
    }

    return like();
  }

  return {
    like,
    unlike,
    onLikeClicked,
  };
}
